module.exports = __webpack_public_path__ + "banquet/components/images/banquet_logo.cec377f3d4f41fc409571f032a551c46.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/banquet_logo.svg
// module id = 532
// module chunks = 1